module.exports = __webpack_public_path__ + "img/saas1-icon.87d59784.png";